import { apiClient } from "./client";

export const NotificationsApi = {
  list: async () => {
    return apiClient.get("/notifications/");
  },

  markRead: async (id) => {
    return apiClient.post(`/notifications/${id}/mark_read/`);
  },

  markAllRead: async () => {
    return apiClient.post("/notifications/mark_all_read/");
  },
};
